import { render, staticRenderFns } from "./BaseInputPrice.vue?vue&type=template&id=53d7097c"
import script from "./BaseInputPrice.vue?vue&type=script&lang=js"
export * from "./BaseInputPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports